<template>
    <router-view/>
</template>

<script>
export default {
  name: 'App'
}
</script>


<style>
.container {
  margin: 0 auto;
  max-width: 900px;
  width: 90%;
}
</style>



// WEBPACK FOOTER //
// src/App.vue